import { Typography, Box } from "@mui/material"
import Layout from "./Layout"
import SecondaryButton from "../../shared/buttons/SecondaryButton"
import Email from "../../shared/fields/Email"
import Password from "../../shared/fields/Password"
import PasswordConfirmation from "../../shared/fields/PasswordConfirmation"
import PhoneNumber from "../../shared/fields/PhoneNumber"
import BirthDate from "../../shared/fields/BirthDate"
import FirstName from "../../shared/fields/FirstName"
import LastName from "../../shared/fields/LastName"
import TermsAndConditions from "../../shared/fields/TermsAndConditions"
import PrivacyData from "../../shared/fields/PrivacyData"
import LoginLink from "./links/Login"
import useAppStore from "../../../store/app"
import { useNavigate } from "react-router-dom"
import BackButton from "../../shared/buttons/BackButton"
import useAlertStore from "../../../store/alert"
import useErrorsCheck from "hooks/use_errors_check"
import useTranslation from "hooks/use_translation"

const Registration = () => {
  const fields = useAppStore((state) => state.fields)
  const updateFieldErrorMessage = useAppStore((state) => state.updateFieldErrorMessage)
  const createClient = useAppStore((state) => state.createClient)
  const syncClient = useAppStore((state) => state.syncClient)
  const showAlert = useAlertStore((state) => state.showAlert)

  const t = useTranslation()
  const navigate = useNavigate()

  const { validate } = useErrorsCheck([
    "first_name",
    "last_name",
    "birthday",
    "phone_number",
    "email",
    "terms_and_conditions",
    "privacy_data",
    "password",
    "password_confirmation",
  ])

  const handleSubmit = (event) => {
    event.preventDefault()

    const valid = validate()
    if (!valid) return

    if (fields.password.input_value !== fields.password_confirmation.input_value) {
      updateFieldErrorMessage(
        "password_confirmation",
        t?.fields?.password_confirmation?.error_not_match,
      )
      return
    }

    const params = {
      first_name: fields.first_name?.input_value,
      last_name: fields.last_name?.input_value,
      phone_number: fields.country_code?.input_value + " " + fields.phone_number?.input_value,
      email: fields.email?.input_value,
      birthday: fields.birthday?.input_value,
      password: fields.password?.input_value,
      terms_and_conditions: fields.terms_and_conditions?.input_value,
      personal_info: fields.privacy_data?.input_value,
    }

    createClient(params)
      .then((response) => {
        syncClient(response.data)
        navigate("/email_confirmation?action=create")
      })
      .catch((error) => showAlert(error?.response?.data?.error_messages, "error"))
  }

  return (
    <Layout>
      <BackButton />
      <Typography variant="h4" sx={{ mb: 1, fontWeight: 700 }}>
        {t?.pages?.registration_page_title}
      </Typography>
      <Typography variant="body1">{t?.pages?.registration_page?.subtitle}</Typography>

      <Box component="form" onSubmit={handleSubmit}>
        <FirstName />
        <LastName />
        <BirthDate />
        <PhoneNumber />
        <Email />
        <Password />
        <PasswordConfirmation />
        <SecondaryButton fullWidth text={t?.pages?.registration_page?.signup} type="submit" />
        <TermsAndConditions />
        <PrivacyData />
      </Box>

      <LoginLink />
    </Layout>
  )
}

export default Registration
